import { useEffect, useState } from "react";
import axios from "axios";

// in-memory cache for development data
let cachedDevelopment = null;
let cachedError = null;

export default function Development() {
  const [data, setData] = useState(Array.isArray(cachedDevelopment) ? cachedDevelopment : []);
  const [loading, setLoading] = useState(cachedDevelopment ? false : true);
  const [error, setError] = useState(cachedError || null);

  useEffect(() => {
    if (cachedDevelopment) {
      setLoading(false);
      return;
    }

    setLoading(true);

    const fetchData = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/development/`);
        const respData = response.data || [];
        // ensure we store an array
        const arr = Array.isArray(respData) ? respData : [];
        setData(arr);
        cachedDevelopment = arr;
      } catch (err) {
        setError(err);
        cachedError = err;
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { data, loading, error };
}
